import { makeStyles } from '@mui/styles';
import { ITheme } from 'theme/types';

type StyleProps = {
  hasChildrenActive: boolean;
  zoomLevel: number;
};

const useStyles = makeStyles<ITheme, StyleProps>(theme => ({
  disabledIcon: {
    color: theme.palette.warning.main,
    fontSize: theme.spacing(2),
    marginLeft: theme.spacing(0.5),
  },
  errorIcon: {
    color: theme.palette.error.main,
    fontSize: theme.spacing(2),
    marginLeft: theme.spacing(0.5),
  },
  iconContainer: ({ zoomLevel }) => ({
    marginLeft: `calc(${theme.spacing(1)} * ${zoomLevel})`,
    opacity: 0,
    transition: 'opacity 0.2s ease-in-out',

    '&.active': {
      opacity: 1,
    },

    // Icon button
    '& .MuiIconButton-root': {
      padding: `calc(5px * ${zoomLevel})`,
    },

    // Icon
    '& .MuiSvgIcon-root': {
      height: `calc(1em * ${zoomLevel}) `,
      width: `calc(1em * ${zoomLevel}) `,
    },
  }),
  childrenContainer: ({ hasChildrenActive }) => ({
    marginTop: theme.spacing(4.5),
    paddingBottom: hasChildrenActive ? theme.spacing(2) : 0,
    paddingTop: hasChildrenActive ? theme.spacing(2) : 0,
    width: '100%',
  }),
  tabPanel: {
    display: 'none',
    paddingBottom: theme.spacing(8),

    '&.active': {
      display: 'block',
    },
  },
}));

export default useStyles;
